import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("label", { style: {"color":"#F56C6C","margin-right":"4px"} }, "*", -1)
const _hoisted_3 = {
  class: "search-container",
  style: {"padding":"0px"}
}
const _hoisted_4 = {
  key: 0,
  class: "search-form-item"
}
const _hoisted_5 = { class: "form-label" }
const _hoisted_6 = {
  key: 0,
  class: "search-form-item"
}
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "search-form-item" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = { class: "search-form-item" }
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = { class: "search-form-item" }
const _hoisted_13 = { class: "search-form-item" }
const _hoisted_14 = { class: "search-form-item" }
const _hoisted_15 = {
  key: 4,
  class: "search-form-item"
}
const _hoisted_16 = { class: "form-label" }
const _hoisted_17 = {
  key: 5,
  class: "search-form-item"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "height200px text-align-center line-height200px font-size16px"
}
const _hoisted_20 = {
  key: 0,
  style: {"color":"#f56c6c"},
  class: "font-size12px"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_tip = _resolveComponent("question-tip")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_device_icon = _resolveComponent("device-icon")
  const _component_list_choose_tag = _resolveComponent("list-choose-tag")
  const _component_el_form = _resolveComponent("el-form")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.$wordList.AutoP,
    onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: _ctx.submit,
    width: "800px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, { "label-position": _ctx.$formLabelPosition }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { error: _ctx.configToLongError }, {
            default: _withCtx(() => [
              _createVNode("label", null, _toDisplayString(_ctx.$wordList.AutoP), 1),
              _createVNode(_component_question_tip, {
                placement: "top-start",
                class: "margin-left5px"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.AutoPTips), 1)
                ]),
                _: 1
              }),
              _hoisted_1,
              _createVNode(_component_el_radio, {
                modelValue: _ctx.AutopType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.AutopType = $event)),
                label: "0"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.RegularAutoP), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_radio, {
                modelValue: _ctx.AutopType,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.AutopType = $event)),
                label: "1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$wordList.OneTimeAutoP), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_input, {
                modelValue: _ctx.Config,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.Config = $event)),
                rows: "5",
                "auto-complete": "off",
                type: "textarea"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["error"]),
          _hoisted_2,
          _createVNode("label", null, _toDisplayString(_ctx.$wordList.ProperAllTextDevice) + "(" + _toDisplayString(_ctx.$wordList.ProperAllTextMaximumTips.format('500')) + ") ", 1),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode("label", null, _toDisplayString(_ctx.$wordList.ProperAllTextSelected) + ": " + _toDisplayString(_ctx.selectDevices.length) + " " + _toDisplayString(_ctx.$wordList.Devices), 1),
              _createVNode("div", _hoisted_3, [
                (_ctx.role === 'disProject' || _ctx.role === 'disPersonal')
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$wordList.ProperAllTextInstaller), 1),
                      _createVNode(_component_cus_select, {
                        modelValue: _ctx.requestData.param.Installer,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestData.param.Installer = $event)),
                        filter: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.installerOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_cus_option, {
                              key: item.ID,
                              label: item.Name,
                              value: item.ID
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.role === 'disProject')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      (_ctx.requestData.param.Installer)
                        ? (_openBlock(), _createBlock("div", _hoisted_6, [
                            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$wordList.ProperAllTextCommunity), 1),
                            _createVNode(_component_cus_select, {
                              modelValue: _ctx.requestData.param.Community,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.requestData.param.Community = $event)),
                              filter: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_cus_option, {
                                  label: _ctx.$wordList.SelectAll,
                                  value: "all"
                                }, null, 8, ["label"]),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.communityOptions[_ctx.requestData.param.Installer], (item) => {
                                  return (_openBlock(), _createBlock(_component_cus_option, {
                                    key: item.ID,
                                    label: item.Name,
                                    value: item.ID
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.role==='com' || (_ctx.role === 'disProject' && _ctx.requestData.param.Installer))
                  ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$wordList.ProperAllTextBuild), 1),
                        _createVNode(_component_cus_select, {
                          modelValue: _ctx.requestData.param.Build,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.requestData.param.Build = $event)),
                          filter: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_cus_option, {
                              label: _ctx.$wordList.SelectAll,
                              value: "all"
                            }, null, 8, ["label"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_cus_option, {
                                key: item,
                                value: item.key,
                                label: item.value
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$wordList.ProperAllTextApt), 1),
                        _createVNode(_component_cus_select, {
                          modelValue: _ctx.requestData.param.Apt,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.requestData.param.Apt = $event)),
                          filter: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_cus_option, {
                              label: _ctx.$wordList.SelectAll,
                              value: "all"
                            }, null, 8, ["label"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.aptOptions, (item) => {
                              return (_openBlock(), _createBlock(_component_cus_option, {
                                key: item,
                                value: item.key,
                                label: item.value
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.role === 'disPersonal')
                  ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                      _createVNode("div", _hoisted_12, [
                        _createVNode(_component_el_input, {
                          placeholder: _ctx.$wordList.ProperAllTextOwner,
                          class: "width200px margin-right10px",
                          modelValue: _ctx.requestData.param.Owner,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.requestData.param.Owner = $event))
                        }, null, 8, ["placeholder", "modelValue"])
                      ]),
                      _createVNode("div", _hoisted_13, [
                        _createVNode(_component_el_input, {
                          placeholder: _ctx.$wordList.FamilySip,
                          class: "width200px margin-right10px",
                          modelValue: _ctx.requestData.param.FamilySip,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.requestData.param.FamilySip = $event))
                        }, null, 8, ["placeholder", "modelValue"])
                      ]),
                      _createVNode("div", _hoisted_14, [
                        _createVNode(_component_el_input, {
                          placeholder: _ctx.$wordList.ProperAllTextMac,
                          class: "width200px margin-right10px",
                          modelValue: _ctx.requestData.param.MAC,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.requestData.param.MAC = $event))
                        }, null, 8, ["placeholder", "modelValue"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (!(_ctx.role === 'disProject' && !_ctx.requestData.param.Installer))
                  ? (_openBlock(), _createBlock("div", _hoisted_15, [
                      _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$wordList.ProperAllTextType), 1),
                      _createVNode(_component_cus_select, {
                        modelValue: _ctx.requestData.param.Type,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.requestData.param.Type = $event)),
                        class: "margin-right10px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_cus_option, {
                            label: _ctx.$wordList.SelectAll,
                            value: "all"
                          }, null, 8, ["label"]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceTypeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_cus_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.role !== 'disPersonal')
                  ? (_openBlock(), _createBlock("div", _hoisted_17, [
                      _createVNode(_component_el_input, {
                        placeholder: _ctx.$wordList.ProperAllTextMac,
                        class: "width200px margin-right10px",
                        modelValue: _ctx.requestData.param.MAC,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.requestData.param.MAC = $event))
                      }, null, 8, ["placeholder", "modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_cus_button, { onClick: _ctx.search }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (!_ctx.isShowList)
                ? (_openBlock(), _createBlock("div", _hoisted_19, _toDisplayString(_ctx.$wordList.AutopSearchTips), 1))
                : _createCommentVNode("", true),
              (_ctx.isShowList)
                ? (_openBlock(), _createBlock(_component_list_choose_tag, {
                    key: 1,
                    "list-type": "pagination",
                    showCheck: "OnlyCheck",
                    headers: _ctx.header,
                    action: false,
                    requestData: _ctx.requestData,
                    showChooseTitle: false,
                    row: 500,
                    update: _ctx.updateToList,
                    onMultipleSelect: _ctx.getMultipleSelect
                  }, {
                    TypeSlot: _withCtx((data) => [
                      _createVNode(_component_device_icon, {
                        class: "vertical-align-middle",
                        type: Number(data.scope['Type'])
                      }, null, 8, ["type"])
                    ]),
                    _: 1
                  }, 8, ["headers", "requestData", "update", "onMultipleSelect"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.isShowSelectTips)
            ? (_openBlock(), _createBlock("label", _hoisted_20, _toDisplayString(_ctx.$wordList.CallSetDeivceOne), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["label-position"])
    ]),
    _: 1
  }, 8, ["title", "onSubmit"]))
}